import React from 'react'
import Layout from '../../../Layout'
import { Box } from '../../../UI'
import { Button, Typography } from '@material-ui/core'
import { Link } from 'react-router-dom';

export default function Success({ match }) {
	const propertyId = match.params.propertyId;
    return (
        <Layout>
            <Box pt='120px' style={{ textAlign: 'center' }}>
                <Typography variant='h3' style={{ marginBottom: '1rem' }}>Letter of Intent successfully sent</Typography>
                <Typography variant='h6' style={{ marginBottom: '2rem' }}>ref: {propertyId}</Typography>
                <Button variant='contained' color='primary' component={Link} to='/market-search'>Back to Market Search</Button>
            </Box>
        </Layout>
    )
}
